<script>
import formatDate, { formatRequestData } from '@utils/format-date'
import lazyLoadComponent from '@router/lazyload-component'
import { genderFilter, bookingStatusFilter, orderPaymentMethodFilter, orderSourceFilter } from '@utils/filter-value-to-text'
export default {
  filters: {
    genderFilter,
    bookingStatusFilter,
    orderPaymentMethodFilter,
    orderSourceFilter,
    formatDate,
  },
  components: {
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: 'order'
    }
  },
  data() {
    return {
      isAddShow: false
    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    hasPrepaidParams(params){
      return params.some(item=>{
        return item.type === 'prepaid'
      })
    },
    showOrderItem() {
      this.$emit('onClick')
    },
    addItems(order) {
      let list = []
      order.params.forEach(item => {
        if (item.type === 'cosmetic-add') {
          list.push(item)
        }
      })
      order.childrenOrders.forEach(item => {
        item.items.forEach(i => {
          if (i.type === 'cosmetic-add') {
            list.push(i)
          }
        })

      })
      return list
    },
    showOrderItemComment() {
      this.$emit('onShoworderItemComment')
    }
  }
}
</script>

<template>
<div :class="$style.ListItem">
  <div class="ListItem__meta d-flex">
    <span v-if="hasPrepaidParams(item.params)" class="info-icon isPrepaid">
      方案抵扣
    </span>
    <span v-else class="info-icon">
      單次預約
    </span>
    <BaseStateLabel :round="true" :state="item.status | bookingStatusFilter('color')" class="is-border is-round">{{ item.status | bookingStatusFilter('text') }}</BaseStateLabel>
  </div>
  <!-- 名字 -->
  <div class="ListItem__name mt-3">
    {{item.pet.name}} - <span
      style="display:inline-block">{{item.customerName}} {{item.customerGender
      | genderFilter}}</span>
    <template v-if="$hasMemberLevel()">
      <el-tag class="isStyleTag ml-2">
        <span class="text-secondary">{{ item.level.title }}</span>
      </el-tag> 
    </template>
  </div>
  <div v-if="type === 'order'" class="ListItem__phone mt-1">
    <span class="text-secondary">{{item.customerPhone}}</span>
  </div>
  <div
    v-if="!!item.tags && item.tags.length > 0"
    class="mt-3"
  >
    <span class="text-muted-0 mb-2">隸屬標籤：</span>
    <el-tag
      v-for="(tag, index) in item.tags" 
      :key="`tag-${index}`" 
      class="isStyleTag"
      disable-transitions
    >
      {{ tag }}
    </el-tag>
  </div>
  <div class="ListItem__time mt-4 text-secondary Jost">
    <div class="time" style="padding-right:10px"> 
      <div class="mb-2">{{ item.startDate | formatDate }}</div>
      <div> {{ item.startDate | formatDate('time') }} - {{ item.endDate | formatDate('time') }}</div>
      <span v-if="item.bufferTime > 0" class="text-muted-0 ml-2">(緩衝時間 {{item.bufferTime }} 分鐘)</span>
    </div>
  </div>
  <div class="ListItem__service mt-4">
    <div class="text-muted-0 mb-1">服務項目</div>
    <div class="mt-2 text-secondary">{{item.productTitle}} {{item.priceTitle}}</div>
    <div class="mt-2 text-secondary">{{item.pet.categoryTitle}}/{{item.pet.sizeTitle}}</div>
  </div>
  <div v-if="type !== 'order' && addItems(item).length > 0" class="ListItem__add mt-4">
    <el-button v-if="!isAddShow" class="w-100 is-round" @click="isAddShow = true">顯示加購項目</el-button>
    <div v-if="isAddShow" class="mt-3 pt-3 dashedTop">
      <div class="text-muted-0 mb-1">加購項目</div>
      <div v-for="(addItem, index) in addItems(item)" :key="index">
        <div style="margin-bottom:6px">{{addItem.title}} <span class="text-muted-0"> -
            {{addItem.serviceTime}} 分鐘</span>
          <!-- <br><span>({{ order.status | orderStatusFilter('text') }})</span> -->
          <span v-if="addItem.paymentStatus === 'PAID'" class="text-success fs-sm"> 已付款</span>
          <span v-if="addItem.paymentStatus === 'UNPAID'" class="text-danger fs-sm"> 未付款</span>
        </div>
      </div>
    </div>
    <el-button v-if="isAddShow" class="w-100 mt-2 is-round" @click="isAddShow = false">隱藏加購項目</el-button>
  </div>
  <div class="d-flex">
    <el-button type="primary"  class="w-100 mt-2 is-round mt-4" @click="showOrderItem">查看訂單</el-button>
    <el-button v-if="type !== 'order'"  class="w-100 mt-2 is-round mt-4" @click="showOrderItemComment"><BaseIcon name="eye"/> 查看備註</el-button>
  </div>
</div>
</template>
<style lang="scss" module>
@import '@src/design/vuecal-override.scss';
.ListItem {
  border: 1px solid #E5E7EB;
  padding: 18px;
  border-radius: 8px;
  :global {
    .ListItem {
      &__meta {
        .info-icon {
          color: #fff;
          background-color: $color-primary;
          display: inline-block;
          padding: 7px 10px;
          font-weight: 300;
          font-size: 14px;
          margin-right: 1rem;
          &.isPrepaid {
            background-color: #2D385F;
          }
        }
      }
      &__name {
        color: $color-secondary;
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
}
</style>
